import React, { Component, useEffect } from 'react';

import ff from './ff';
import bf from './bf';
import cf from './cf';
import ic from './ic';
import cr from './cr';
//import { forFade } from '@react-navigation/stack/lib/typescript/src/TransitionConfigs/HeaderStyleInterpolators';

export default class cView extends Component {

  $cd_stss = {}; // 外部で定義
  $id_stss = {}; // 外部で定義

  $cp_onEtr = () => new Promise( _o_end1 => { _o_end1() }); // on enter
  $ip_onEtr = () => new Promise( _o_end1 => { _o_end1() }); // on enter

  $cp_onExit = () => new Promise( _o_end1 => { _o_end1() }); // on exit
  $ip_onExit = () => new Promise( _o_end1 => { _o_end1() }); // on exit

  $clp_bfrLoadLists = () => []; // ins/upd の前処理
  $ilp_bfrLoadLists = () => []; // ins/upd の前処理

  $clp_loadLists = () => []; // 外部で定義　※関数でない場合は値が固定化される模様
  $ilp_loadLists = () => []; // 外部で定義

  $clp_loadDtls = () => []; // 外部で定義　※関数でない場合は値が固定化される模様
  $ilp_loadDtls = () => []; // 外部で定義

  $clp_bfrIuds = () => []; // ins/upd の前処理
  $ilp_bfrIuds = () => []; // ins/upd の前処理

  $cp_ins = null; // 外部で定義
  $ip_ins = null; // 外部で定義

  $clp_upds = () => []; // 外部で定義
  $ilp_upds = () => []; // 外部で定義

  $clp_atrUpds = () => []; // 外部で定義
  $ilp_atrUpds = () => []; // 外部で定義

  $clp_dlts = () => []; // 外部で定義
  $ilp_dlts = () => []; // 外部で定義

/* 最終要素でのみ実行
  constructor(props) { // global.t は使用不可
    super(props);
    this.class = this.constructor.name;
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
    bf.myCM_clw(60, () => {}); // 定期的に実行する処理を記述 他の画面へ遷移した場合も継続実行されることに注意
    cf.myLS_get('tkn').then((_tkn) => { // tkn が設定されていない場合　ログアウト
      if (!bf.f(_tkn)) { // myRN_logout の場合 global.t? が指定されており正常に動作しない模様
        cf.myRN_logout();
      };
    });
  }
*/

_op_loadMenu = (pd={
}) => new Promise( _o_end1 => {
  if (!global.t?.state.sgcd_cmnStgs.c20r_fst || !global.t?.state.sgcd_cmnStgs.c10r_key) { // c00v は実行対象外
    _o_end1();
  }
  else {
    let _cnd = cf.c('c40r', `
      t_c40r._key IN (
        SELECT
          A.c410b41k
        FROM
          t_c410 AS A
        WHERE
          COALESCE(A.c410cz1i, 10) <> 0
          AND A.c410b21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst}
          AND A.c410b51k IN (
            SELECT
              B._key
            FROM
              t_c41r AS B
            WHERE
              COALESCE(B.c41rcz1i, 10) <> 0
              AND B.c41rb21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst}
              AND B._vsn = B._ltt
              AND B._fst IN (
                SELECT
                  C.c420b51f
                FROM
                  t_c420 AS C
                WHERE
                  COALESCE(C.c420cz1i, 10) <> 0
                  AND C.c420b21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst}
                  AND C._vsn = C._ltt
                  AND C.c420b61k IN (
                    SELECT
                      D._key
                    FROM
                      t_c42r AS D
                    WHERE
                      COALESCE(D.c42rcz1i, 10) <> 0
                      AND D.c42rb21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst}
                      AND D._vsn = D._ltt
                      AND D.c42rb11k = ${global.t?.state.sgcd_cmnStgs.c10r_key}
                  )
              )
          )
      )
    `, true, false);
    //ff.l('102: {}'.f(_cnd))
    cf.myCB_call_slc({
      elm: 'c40r',
      n_dms: 3,
      cnd: _cnd,
      ld_sortss: [
        {fld: 'c40rc11s', dtn: 'asc', mode: 'nmb'},
      ],
    })
    .then( _ld_rss => {
      let _dd_pageDefss = {};
      _ld_rss.map( _d_rs => {
        _dd_pageDefss[_d_rs.c40ri11s] = {
          ..._d_rs,
          b_vsb: true,
          pfx:_d_rs.c40rc31s,
          sgc_pageRole: global.t?.state.sgc_pageRole,
          sgc_pageName: _d_rs.c40ri11s,
        };
      });
      _dd_pageDefss = {
        ..._dd_pageDefss,
        logout: {
          b_vsb: true,
          fnc:'logout', 
          pfx:'ログアウト',
        },
      };
      cf.myRN_setStt({
        sgcdd_menuDefss: _dd_pageDefss,
      })
      .then(() => {
        _o_end1();
      });
    });
  };
});


  componentDidMount = async () => {

    cf.myRN_stt(this, async ()=>{ // 画面遷移時の再描画に必要 1/2
      this.d_crls.b_hdn = false; // 表示中
      //ff.l('cView 148: here')
      await global.t?._op_loadMenu();
      cf.myRN_pll([
        this.$cp_onEtr(), // on enter
        this.$ip_onEtr(),
      ])
      .then(() => {
        //ff.l('cView 155: here')
        this.op_loadListAll()
        .then(() => {
          if (this.state.sgc_pnlMode == 'dtl') { // 他ページから遷移の場合 loadListAll でパラメータを読み込んだ後、loadDtlAll 
            this.op_loadDtlAll();
          };
        });
      });
    });

    ff.myCM_clw(3, () => { // clock work
      const _lastOrnDtm = global.d_crls.lastOrnDtm ?? ff.myDT_getNow();
/*
console.log('cView 172: {}, {}, {}'.f(
  global.d_crls.lastOrnDtm,
  ff.myDT_getNow(),
  _lastOrnDtm,
));
*/
      cf.myLS_set('lastOrnDtm', _lastOrnDtm);
      global.d_crls.n_noOrnTime = ff.myDT_getDff('scd', _lastOrnDtm, ff.myDT_getNow()); // 無操作時間の更新
/*
console.log('cView 179: {}, {}, {}'.f(
  _lastOrnDtm,
  ff.myDT_getNow(),
  global.d_crls.n_noOrnTime
));
*/
      if (this.d_crls.b_hdn == false) {
        if (this._o_clwForNotHdn) this._o_clwForNotHdn(); // clockwork not for hidden
      }
      else {
        if (this._o_clwForHdn) this._o_clwForHdn(); // clockwork for hidden
      };
      if (this._o_clwForEvy) this._o_clwForEvy(); // clock work for every
    });

  }

_o_clwForNotHdn = pd => { // clock work for not hidden
  if (
    this.state.sgcd_cmnStgs.c10rt11i == 10 && // 団体
    global.d_crls.n_noOrnTime > 3600
  ) {
    cf.myLS_set('lastOrnDtm', ff.myDT_getNow()); // 再ログインのための初期化
    cf.myRN_logout();
  }
/*
console.log('cView 202: {}, {}, {}'.f(
  this.state.sgcd_cmnStgs.c10rt11i,
  this.d_viewDefs.class,
  global.d_crls.n_noOrnTime
));
*/
  if (
    this.state.sgcd_cmnStgs.c10rt11i == 20 && // スタッフ
    bf.i(this.d_viewDefs.class, ['i1zv3b']) == false && // サイネージは対象外 
    global.d_crls.n_noOrnTime > 1800
  ) {
    let _d_pageInfs = { // ユーザ切替画面
      sgc_pageRole: global.t?.state.sgc_pageRole,
      sgc_pageName: 'c00v2a',
      sgc_pageMode: 'show',
    };
    cf.myLS_set('lastOrnDtm', ff.myDT_getNow()); // 再ログインのための初期化
    cf.myRN_move_fwd(_d_pageInfs);
  }
}

componentWillUnmount() { // 画面遷移時の再描画に必要 2/2
  cf.myRN_end();
}

op_onExit = () => new Promise( _o_end1 => { // 他の画面へ遷移する際の処理を記述　現行、move_bwd は対応できていない
  cf.myRN_pll([
    this.$cp_onExit(),
    this.$ip_onExit(),
  ])
  .then(() => {
    this.d_crls.b_hdn = true; // 非表示中
    _o_end1();
  });
});

static op_loadSlcList = (pd={
  elm: null,
  state: null,
  o_cnd: null,
  dd_rfrss,
  ld_sortss: null,
  od_fmts: null,
  b_vsn: false,
  b_fnd: false,
}) => cr.myCB_call_tree({
  ctr: 'slc',
  state: pd.state ?? `sdld_${pd.elm}SlcListsss`,
  b_ltt: (pd.b_vsn == false) ? false : true,
  dd_elmDefss: {
    [pd.elm]: { // alias
      elm: pd.elm,
      n_lmt: ic.gn_lmt,
      o_cnd: pd.o_cnd ?? (_dd_datss => {
        let _cnd = pd.cnd ?? cf.c(pd.elm, null, pd.b_fnd ?? false);
        return _cnd;
      }),
      dd_rfrss: pd.dd_rfrss ?? null,
      ld_sortss: pd.ld_sortss ?? [
        { fld: `${pd.elm}c11s`, dtn: 'desc', mode: 'nmb'},
      ],
      od_fmts: pd.od_fmts ?? (_d_dats => {
        let _d = {
          ..._d_dats,
          key: (pd.b_vsn != false) ? _d_dats.d_flds._fst : _d_dats.d_flds._key, // 暦対応
          pfx: `${_d_dats.d_flds[`${pd.elm}c31s`]}`, 
          sch: `${_d_dats.d_flds[`${pd.elm}c11s`]} ${_d_dats.d_flds[`${pd.elm}c31s`]}`, 
        };
        if (ic.gb_dbg) bf.l('cView 210: {}'.f(_d_dats.d_flds))
        if (ic.gb_dbg) bf.l('cView 211: {}'.f(_d))
        return _d;
      }),
    },
  },
  op_atrAll: 
    (pd.op_atrAll) ?
      pd.op_atrAll
    : (ic.gb_dbg) ?
      () => new Promise( _o_end1 => { 
        bf.l('cView 220: {}, {}'.f(pd.elm, global.t?.state[`sdld_${pd.elm}SlcListsss`]))
        _o_end1();
      })
    : null,
});

static op_loadVsnList = (pd={
  elm: null,
}) => cr.myCB_call_tree({
  ctr: 'slc',
  state: pd.state ?? `sdld_${pd.elm}VsnListsss`,
  b_ltt: false,
  dd_elmDefss: {
    [pd.elm]: { // alias
      elm: pd.elm,
      o_cnd: pd.o_cnd ?? (_dd_datss => {
        let _cnd = pd.cnd ?? cf.c(pd.elm, `_fst = ${global.t?.state.sgc_pageFst}`, false, false)
        return _cnd;
      }),
      ld_sortss: [
        { fld: '_vsn', dtn: 'desc', mode: 'nmb'},
      ],
      od_fmts: pd.od_fmts ?? (_d_dats => bf.c(_d_dats, {
        key: _d_dats.d_flds._key, 
        pfx: `${_d_dats.d_flds[`${pd.elm}cy1t`]}`, 
        sch: `${_d_dats.d_flds[`${pd.elm}cy1t`]}`, 
      })),
    },
  },
  op_atrAll: 
    (pd.op_atrAll) ?
      pd.op_atrAll
    : (ic.gb_dbg) ?
      () => new Promise( _o_end1 => { 
        bf.l('cView 261: {}, {}'.f(pd.elm, global.t?.state[`sdld_${pd.elm}VsnListsss`]))
        _o_end1();
      })
    : null,
});

static op_loadList = (pd={
  elm: null,
  state: null,
  o_cnd: null,
  ld_sortss: null,
  b_vsn: false,
}) => cr.myCB_call_tree({
  ctr: 'slc',
  state: pd.state ?? `sdld_${pd.elm}Listsss`,
//  b_ltt: (pd.b_vsn) ? pd.b_vsn : true,
  b_ltt: 
    (pd.b_vsn == false) ?
      false
    : true,
  dd_elmDefss: {
    [pd.elm]: { // alias
      elm: pd.elm,
      n_lmt: ic.gn_lmt,
      o_cnd: pd.o_cnd ?? (_dd_datss => {
        let _cnd = pd.cnd ?? cf.c(pd.elm, null, pd.b_fnd ?? false, (pd.b_fnd == true) ? false : true);
        return _cnd;
      }),
      dd_rfrss: pd.dd_rfrss ?? null,
      ld_sortss: pd.ld_sortss ?? [
        { fld: `${pd.elm}c11s`, dtn: 'asc', mode: 'nmb'},
      ],
      dd_cldDefss: pd.dd_cldDefss ?? null,
    },
  },
  op_atrAll: 
    (pd.op_atrAll) ?
      pd.op_atrAll
    : (ic.gb_dbg) ?
      () => new Promise( _o_end1 => { 
        bf.l('cView 295: {}, {}'.f(pd.elm, global.t?.state[`sdld_${pd.elm}Listsss`]))
        _o_end1();
      })
    : null,
});

static op_loadDtl = (pd={
  elm: null,
  state: null,
  o_cnd: null,
  key: null,
  fst: null,
  op_atrAll: null,
}) => cr.myCB_call_tree({
  ctr: 'slc',
  state: pd.state ?? `sdld_${pd.elm}Dtlsss`,
  b_ltt: (pd.key) ? false : true,
  dd_elmDefss: {
    [pd.elm]: { // alias
      elm: pd.elm,
      o_cnd: pd.o_cnd ?? (_dd_datss => { // 歴対応のため、key / fst が指定されている場合の扱いを定義要
        let _cnd = pd.cnd ??
          (pd.key) ?
            cf.c(pd.elm, `_key = ${pd.key}`, false, false) // 履歴対応 dd_cldDefss の cf.c も必ず b_ltt = false を設定 -> call_tree において強制適用？
          : (pd.fst) ?
            cf.c(pd.elm, `_fst = ${pd.fst}`) 
          : cf.c(pd.elm, `_fst = ${global.t?.state.sgc_pageFst}`);
//ff.l('cView 350: {}'.f(_cnd));
        return _cnd;
      }),
      d_insFlds: pd.d_insFlds ?? null,
      dd_rfrss: pd.dd_rfrss ?? null,
      dd_cldDefss: pd.dd_cldDefss ?? null,
    },
  },
  op_atrAll: 
    (pd.op_atrAll) ?
      pd.op_atrAll
    : (ic.gb_dbg) ?
      () => new Promise( _o_end1 => { 
        bf.l('cView 321: {}, {}'.f(pd.elm, global.t?.state[`sdld_${pd.elm}Dtlsss`]))
        _o_end1();
      })
    : null,
});


  op_loadListAll = (pd={
    b_clr: false,
  }) => new Promise( _o_end1 => {
    cf.s();
    new Promise( _o_end2 => {
      if (pd.b_clr != false) {
        global.t?.setState(bf.myCM_upd( // load との統一が必要か
          global.t?.$cd_stss,
          global.t?.$id_stss
        ), () => {
          _o_end2();
        });
      }
      else {
        _o_end2();
      };
    })
    .then(() => {
      cf.myRN_pll(bf.myCM_join( // ins/upd の前処理
        global.t?.$clp_bfrLoadLists(),
        global.t?.$ilp_bfrLoadLists()
      ))
      .then((_b_res)=>{
        cf.myRN_load(bf.myCM_join(
          global.t?.$clp_loadLists(),
          global.t?.$ilp_loadLists()
        ))
        .then(() => {
//ff.l('cView 409: here')
          cf.h();
//ff.l('cView 411: here')
//          if (global.t?.$opb_chk) global.t?.$opb_chk(false); // チェック処理
          _o_end1();
        });
      });
    });
  });

/*
  op_loadDtlAll = () => new Promise( _o_end1 => {
    cf.myRN_load(bf.myCM_join(
      global.t?.$clp_loadDtls(),
      global.t?.$ilp_loadDtls()
    ))
    .then(() => { // この段階では、sgc_pnlMode が変更されていないため opb_chk を行わない
      _o_end1();
    });
  });
*/
  op_loadDtlAll = () => new Promise( _o_end1 => {
    cf.myRN_load(bf.myCM_join(
      global.t?.$clp_loadDtls(),
      global.t?.$ilp_loadDtls()
    ))
    .then(() => { // この段階では、sgc_pnlMode が変更されていないため opb_chk を行わない
      _o_end1();
    });
  });

  op_upd = () => new Promise( _o_end1 => {
    cf.s();
    cf.myRN_pll(bf.myCM_join( // ins/upd の前処理
      global.t?.$clp_bfrIuds(),
      global.t?.$ilp_bfrIuds()
    ))
    .then((_b_res)=>{
//ff.l('418: here')
      if (_b_res != false) { // 異常でない場合のみ更新
        cf.myRN_pll(bf.myCM_join(
          global.t?.$clp_upds(),
          global.t?.$ilp_upds()
        ))
        .then(()=>{
//ff.l('425: here')
          cf.myRN_pll(bf.myCM_join(
            global.t?.$clp_atrUpds(),
            global.t?.$ilp_atrUpds()
          ))
          .then(()=>{
//ff.l('431: here')
            cf.myRN_savePageStgs({
              sgc_pageMode: 'show'
            })
            .then(()=>{
//ff.l('436: here')
              global.t?.op_loadListAll()
              .then(() => {
//ff.l('439: here')
                global.t?.op_loadDtlAll()
                .then(() => {
//ff.l('442: here')
                  cf.h();
                  _o_end1();
                });
              });
            });
          })
        });
      };
    })
  });

  op_dltAll = () => new Promise( _o_end1 => {
    cf.myRN_load(bf.myCM_join(
      global.t?.$clp_dlts(),
      global.t?.$ilp_dlts()
    ))
    .then(() => {
      _o_end1();
    });
  });

  $onPrsTab = pd_prms => new Promise( _o_end1 => {
    global.t?.setState({
      sgcn_pageTab: pd_prms.n_tab,
    }, () => {
      _o_end1();
    });
  });

  $cld_onChgss = () => [ // common app
  ];

  $ild_onChgss = () => [ // individual app
  ];

  $pld_onChgss = () => [ // practical module
  ];


//  $ido_onChgs = () => ip.ido_onChgss();
  $pdo_onChgs = () => ({});

};
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */

